module.exports = __webpack_public_path__ + "img/ywyk-instructions04.b536b329.jpg";